import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { Controller } from "react-hook-form";

export const FCheckField: React.FC<FBasicPropos> = ({ field, control, errors,  }) => {
    const { name, editable, icon, inputProps, props, onChange } = field;
    
    
    return (
        <FormControlLabel
            control={
                <Controller
                    name={name}
                    control={control}
                    // defaultValue={defaultValue ? defaultValue : false}
                    render={({ field: controllerField }) => (
                        <div>
                            <Checkbox {...controllerField} color="primary" inputProps={{ ...inputProps }} {... props}/>
                            {errors[name] && (
                                <FormHelperText style={{ color: "red" }}>
                                    {"TEMP ERROR MESSAGE"}
                                </FormHelperText>
                            )}
                        </div>
                    )}
                />
            }
            label={field.question}
        />
    );
};
